import * as Sentry from '@sentry/react';

const isDevelopment = import.meta.env.DEV;
const isProduction = import.meta.env.PROD;

export const sentryConfig: Sentry.BrowserOptions = {
  dsn: 'https://fb5bd3b837f70b0d4b69da360f265f7a@insights.monitor.cluster.2loewen.de/22',

  // Environment configuration
  environment: isDevelopment ? 'development' : isProduction ? 'production' : 'staging',

  // Performance monitoring
  tracesSampleRate: isDevelopment ? 1.0 : 0.1, // Higher sampling in dev, lower in prod
  profilesSampleRate: isDevelopment ? 1.0 : 0.1,

  // Error filtering - exclude sensitive data
  beforeSend(event, hint) {
    // Filter out development errors in production
    if (isProduction && event.exception) {
      const error = hint.originalException;
      if (error instanceof Error && typeof error.message === 'string' && error.message.includes('Non-Error promise rejection')) {
        return null;
      }
    }

    // Remove sensitive data from event context
    if (event.user) {
      delete event.user.email;
      delete event.user.ip_address;
    }

    if (event.request) {
      delete event.request.cookies;
      delete event.request.headers;
    }

    return event;
  },

  // Additional tags for better organization
  initialScope: {
    tags: {
      application: 'administration-portal',
      port: '4201',
      component: 'frontend'
    }
  },

  // Integration configuration
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
      // Only record replays for errors in production
      maskAllText: true,
      blockAllMedia: true,
    }),
  ],

  // Replay configuration
  replaysSessionSampleRate: isDevelopment ? 1.0 : 0.1,
  replaysOnErrorSampleRate: 1.0,

  // Debug configuration
  debug: isDevelopment,

  // Release tracking
  release: `administration-portal@${import.meta.env.VITE_APP_VERSION || '1.0.0'}`,
};

export const initSentry = () => {
  Sentry.init(sentryConfig);
};